
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-industry",
      function () {
        return require("private-next-pages/all-industry.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-industry"])
      });
    }
  